import { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createClient, UsermavenProvider } from '@usermaven/react';
import TaxarooRoutes from './routes';
import 'taxaroo-ui/dist/index.css';

// https://app.usermaven.com/env/UM2bqclomL/setup-guides/integration?type=react
const usermavenClient = createClient({
  key: 'UM2bqclomL',
});

const App: FC = () => (
  <UsermavenProvider client={usermavenClient}>
    <BrowserRouter>
      <TaxarooRoutes />
    </BrowserRouter>
  </UsermavenProvider>
);

export default App;
